import React from 'react';
import { Link, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import { LANG_PATH } from 'app-router/app-router';
import styles from 'components/footer/index.module.scss';
import { useTranslation } from 'react-i18next';
import logo from 'images/logo-mochi-simple-gray.svg';
import classnames from 'classnames/bind';
import { amplitudeEvent } from 'components/navbar/navbar';
import { contactFormUrl } from 'config';
import { termsUrl } from 'config';
import { privacyUrl } from 'config';

const Footer = React.memo(({ menus }) => {
  const cx = classnames.bind(styles);
  const langMatch = useRouteMatch(LANG_PATH);
  const langPath = langMatch.params.locale === undefined ? '' : `/${langMatch.params.locale}`;
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const { language } = useTranslation().i18n;
  const location = useLocation();
  const history = useHistory();

  const MenuLink = ({ menu }) => {
    if (menu.isInternalLink) {
      return (
        <Link to={langPath + menu.path} onClick={() => amplitudeEvent(menu, 'footer')}>
          {menu.name}
        </Link>
      );
    } else {
      return (
        <a href={menu.path} target="_blank" rel="noopener noreferrer">
          {menu.name}
        </a>
      );
    }
  };

  const SubMenuItem = ({ menu }) => {
    return (
      <li className={styles.link}>
        <MenuLink menu={menu} />
      </li>
    );
  };

  const SubMenuGroup = ({ subMenu }) => {
    return (
      <ul className={styles.item}>
        <li className={styles.title}>{subMenu.name}</li>
        {subMenu.menus.map(menu => {
          return <SubMenuItem key={menu.path} menu={menu} />;
        })}
      </ul>
    );
  };

  const LangSwitch = () => {
    const langList = [
      {
        htmlAttr: 'zh-Hant-TW',
        lang: 'tw',
        langUrl: '',
        name: '中文',
      },
      { htmlAttr: 'en', lang: 'en', langUrl: '/en', name: 'EN' },
    ];

    return langList.map(({ lang, htmlAttr, langUrl, name }) => {
      const langClass = cx({
        active: language === lang,
      });

      return (
        <li
          className={langClass}
          key={lang}
          onClick={() => {
            if (langPath !== langUrl) {
              history.push(`${langUrl}/${location.pathname.split('/').pop()}`);
              i18n.changeLanguage(lang);
              document.getElementsByTagName('html')[0].setAttribute('lang', htmlAttr);
            }
            window.scrollTo(0, 0);
          }}
        >
          {name}
        </li>
      );
    });
  };

  const footerClass = cx({
    footer: true,
    hide:
      location.pathname.includes('/promotion') ||
      location.pathname.includes('/gas-stations') ||
      location.pathname.includes('/car-beauty-stores') ||
      location.pathname.includes('/auto-repair-stores') ||
      location.pathname.includes('/car-wash-stores') ||
      location.pathname.includes('/parkinglots') ||
      location.pathname.includes('/user'),
  });

  return (
    <div className={footerClass}>
      <img className={styles.logo} src={logo} alt="logo" />
      <div className={styles.menu}>
        {menus.map(subMenu => {
          return <SubMenuGroup key={subMenu.name} subMenu={subMenu} />;
        })}
      </div>
      <div className={styles.info}>
        <div className={styles['company-info']}>
          <span className={styles['copy-right']}>Copyright © 2019 PKLOTCORP INC. All Rights Reserved.</span>
          <ul className={styles.about}>
            <li>
              <a href={privacyUrl()}>{t('footer.privacy_policy')}</a>
            </li>
            <li>
              <a href={termsUrl()}>{t('footer.terms_of_service')}</a>
            </li>
            <li>
              <a href={contactFormUrl()}>{t('footer.custom_service_email')}</a>
            </li>
          </ul>
        </div>
        <ul className={styles.lang}>
          <LangSwitch />
        </ul>
      </div>
    </div>
  );
});

export default Footer;
